export default __webpack_public_path__ + "static/media/bonding-staking-icon.ce52cf74.svg";